
//Contact Management 
const GetContactDetails = "ClientContactManagement/GetUsersByAgentId"

//Billing
const GetSalesInvoicesForAgent = 'Invoice/GetSalesInvoicesForAgent'
const GetInvoiceDocument = 'Invoice/GetInvoiceDocument'
const GetWorkorderDocuments = 'Invoice/GetWorkorderDocuments'
const GetInvoiceListByAgent = 'Invoice/GetInvoiceListByAgent'

const PaymentHistory = 'Transactions/GetTransactionsByAgentId'
const GetBaseWorkOrderData = 'Transactions/GetBaseWorkOrderData'
const UpdateWorkorder = 'Transactions/CreateTransaction'
const GetValidatedTransactionsInvoices = 'Transactions/GetValidatedTransactionsInvoices'
const GetTransactionById = "Transactions/GetTransactionById"

const GetAccountDetailsForAgent = 'Agent/GetAccountDetailsForAgent'
const GetAgentAccountStatement = 'Agent/GetAgentAccountStatement'
const GetAgentDetails = 'Agent/GetAgentDetails'

//frb
const GetFRBByAgentNumber = 'FinancialResponsibility/GetFRBByAgentNumber'
const CreateFRBWorkOrder = 'FinancialResponsibility/CreateFRBWorkOrder'
const CancelRequestbyWorkorderId = 'FinancialResponsibility/CancelRequestbyWorkorderId'
const GetRequestQueuebyAgentNumber = 'FinancialResponsibility/GetRequestQueuebyAgentNumber'
const GetFRBClientRoles = 'FinancialResponsibility/GetFRBClientRoles'
const GetAllGroups = "FinancialResponsibility/GetAllGroups"
const GetAllRoles = "FinancialResponsibility/GetAllRoles"
const GetVesselsByAgentId = "FinancialResponsibility/GetVesselsByAgentId"
const GetBilltoPartyInformation = "FinancialResponsibility/GetBilltoPartyInformation"
const GetFRPDetails = "FinancialResponsibility/GetFRPDetails"
const CreateFRPWorkOrder = "FinancialResponsibility/CreateFRPWorkOrder"
const GetSalesInvoicesCountForAgent = "Invoice/GetSalesInvoicesCountForAgent"

const ImpersonateUser = 'User/ImpersonateUser'
const UnlistedUser = 'Dashboard/SendVerificationEmail'
const SendFeedbackEmail = 'Dashboard/SendFeedbackEmail'
const GetUserDetailsByEmailId = "/ClientContactManagement/GetUsersDetailsByEmail"
//Tonnage Tax
const TonnageForAgents = "Tonnage/TonnageForAgents"
const GetTonnageAgentReceipt = "Tonnage/GetTonnageAgentReceipt"
const GetClientTypeByOfficialNumber = 'Tonnage/GetClientTypeByOfficialNumber'
const GetTonnageTaxAttestationLetterDetail = "Tonnage/GetTonnageTaxAttestationLetterDetail"
const GetTonnageTaxAmount = "Tonnage/GetTonnageTaxAmount"
const SaveTonnageTaxAttestation = "Tonnage/SaveTonnageTaxAttestation"
const TonnageGetAgentDetails = "Tonnage/GetAgentDetails"
export const ApiUrls = {
  GetContactDetails,
  GetSalesInvoicesForAgent,
  GetInvoiceDocument,
  GetTonnageAgentReceipt,
  GetWorkorderDocuments,
  GetInvoiceListByAgent,
  PaymentHistory,
  GetBaseWorkOrderData,
  UpdateWorkorder,
  GetValidatedTransactionsInvoices,
  GetTransactionById,
  GetAccountDetailsForAgent,
  GetAgentAccountStatement,
  GetUserDetailsByEmailId,
  GetAgentDetails,
  TonnageGetAgentDetails,
  GetFRBByAgentNumber,
  CreateFRBWorkOrder,
  CancelRequestbyWorkorderId,
  GetRequestQueuebyAgentNumber,
  GetFRBClientRoles,
  GetAllGroups,
  GetAllRoles,
  GetVesselsByAgentId,
  GetSalesInvoicesCountForAgent,
  GetBilltoPartyInformation,
  GetFRPDetails,
  CreateFRPWorkOrder,
  ImpersonateUser,
  UnlistedUser,
  SendFeedbackEmail,
  TonnageForAgents,
  GetClientTypeByOfficialNumber,
  GetTonnageTaxAttestationLetterDetail,
  GetTonnageTaxAmount,
  SaveTonnageTaxAttestation
}